import {
  CLEAR_KEYTERM,
  HIDE_LINKBAR,
  HIDE_SIDEBAR,
  SET_KEYTERM,
  TOGGLE_LINKS_SIDEBAR,
  TOGGLE_SHARE_MODAL,
  TOGGLE_SIDEBAR,
  UPDATE_CURRENT_TOPIC,
  UPDATE_CURRENT_LANGUAGE,
  UPDATE_SHARES_COUNT,
  UPDATE_SHARES_ID,
  TOGGLE_BADGE_MODAL,
  TOGGLE_SHARE_BADGE_MODAL,
  TOGGLE_UPDATE_SIDEBAR,
  TOGGLE_SWEEPSTAKES_BADGE_MODAL,
  SHOW_SWEEPSTAKES_BADGE_MODAL,
} from "../actionTypes";

const INITIAL_STATE = {
  sidebar: false,
  linksSidebar: false,
  keyTerm: false,
  currentTopicContentKey: null,
  showShareModal: false,
  showBadgeModal: false,
  showShareBadgeModal: false,
  showSweepstakesModal: null,
  updateSidebar: false,
  lang: "en",
  shares: 0,
  shareId: "",
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return { ...state, sidebar: !state.sidebar };
    case TOGGLE_LINKS_SIDEBAR:
      return { ...state, linksSidebar: !state.linksSidebar };
    case SET_KEYTERM:
      return { ...state, keyTerm: action.keyTerm };
    case CLEAR_KEYTERM:
      return { ...state, keyTerm: false };
    case UPDATE_CURRENT_TOPIC:
      return { ...state, currentTopicContentKey: action.contentKey };
    case HIDE_SIDEBAR:
      return { ...state, sidebar: false };
    case HIDE_LINKBAR:
      return { ...state, linksSidebar: false };
    case TOGGLE_SHARE_MODAL:
      return { ...state, showShareModal: !state.showShareModal };
    case UPDATE_CURRENT_LANGUAGE:
      return { ...state, lang: action.lang };
    case UPDATE_SHARES_COUNT:
      return { ...state, shares: action.shares };
    case UPDATE_SHARES_ID:
      return { ...state, shareId: action.id };
    case TOGGLE_BADGE_MODAL:
      return { ...state, showBadgeModal: !state.showBadgeModal };
    case TOGGLE_SWEEPSTAKES_BADGE_MODAL:
      return { ...state, showSweepstakesModal: null };
    case SHOW_SWEEPSTAKES_BADGE_MODAL:
      return { ...state, showSweepstakesModal: action.payload };
    case TOGGLE_SHARE_BADGE_MODAL:
      return { ...state, showShareBadgeModal: !state.showShareBadgeModal };
    case TOGGLE_UPDATE_SIDEBAR:
      return { ...state, updateSidebar: !state.updateSidebar };
    default:
      return state;
  }
};

export default reducer;
